import { Component, OnInit, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
declare var $;

@Component({
  selector: 'kms-tree-box',
  templateUrl: './kms-tree-box.component.html',
  styleUrls: ['./kms-tree-box.component.css']
})
export class KmsTreeBoxComponent implements OnInit {

  constructor(
    private el: ElementRef,
    private kmsService: KmsService,
    private box: SwMassageBoxService) { }

  ngOnInit() {
  } 

  /**
   * 输入属性
   */
  @Input() filter: any;

  /**
   * 是否禁止操作 disabled
   */
  @Input() disabledValue: boolean = false;

  /**
   * 输入属性
   */
  @Input() ids: string;

  /**
   * 输入属性
   */
  @Input() elem: ElementRef;

  /**
   * 展现关闭下拉
   */
  @Input() dropdown: boolean = false;

  /**
   * 输出属性
   */
  @Output() closeSelect = new EventEmitter();

  /**
   * 下拉框的高度,不传默认根据内容自动设置
   */
  @Input() height: string = '250px';

  /**
 * 是否有搜索框
 */
  @Input() isSearch: boolean = false;

  /**
   * 是否允许新增
   */
  @Input() addEnable: boolean = false;

  /**
   * 0：关系树展示；1：概念树展示
   */
  @Input() treeType: number = 0;

  /**
   * 不允许选择父节点
   */
  @Input() parentNodeDisabled: boolean = false;

  /**
   * 不允许选择的节点id
   */
  @Input() readonlySelfIds: any = [];

  /**
   * 同步默认打开到第几节点
   */
  @Input() openNode: number;

  // 自定义打开到第几节点
  openLevel: number = 2;
  /**
   * 是否通过所属概念组添加关系
   */
  @Input() conceptGroup: any = {
    sourceConceptId: '',
    sourceConceptName: '',
    targetConceptId:'',
    targetConceptName:''
  };

  /**
   * 传入的数据组
   */
  @Input() data: any = [];
 /**
   * select下拉框箭头 downArrow （即box显示的位置，下方down和右方right，默认为下方）
   */
  @Input() downArrow: string = 'down';
  /**
   * select下拉框箭头向右，且为特殊样式类型2；默认类型为1
   */
  @Input() isStyle: string = '1';
  /**
   * 是否有搜索结果
   */
  hasRes = true;
  ngAfterViewInit(): void {
    // 获取input的dom元素
    var search = document.getElementById(this.ids);
    //如果有搜索框则给焦点
    if (this.isSearch == true) {
      setTimeout(() => {
        if(!this.disabledValue){
          // 自动获取焦点
          search.focus()
        }
      }, 200)
    }
    // 获取元素的位置及大小信息
    let postion = this.elem.nativeElement.getBoundingClientRect()
    // 固定定位
    this.el.nativeElement.style.position = 'fixed';
    // 设置层级
    this.el.nativeElement.style.zIndex = 9990;
    if(this.downArrow == 'right') {
      if(this.isStyle == '2'){
        // 设置定位left
        this.el.nativeElement.style.left = postion.right + 4+ 6 + 'px';
      }else {
         // 设置定位left
         this.el.nativeElement.style.left = postion.right + 4 + 'px';
      }
      
    }else {
      // 设置定位left
      this.el.nativeElement.style.left = postion.left + 'px';
    }
    
    // 设置宽度
    this.el.nativeElement.style.width = postion.width + 'px';
    
    let height = this.height.split('px')[0]
    let clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    // 获取页面滚动部分高度
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    let heightAndTop = clientHeight + scrollTop
    if(this.downArrow == 'right') {
      // 如果下面展示不下去，就展示在上面
      if((heightAndTop-postion.top)<parseInt(height) ){
        this.el.nativeElement.style.top = postion.bottom - parseInt(height) +15 + 34 + 'px';
      }else {
        this.el.nativeElement.style.top = postion.top + 'px';
      }
    }else {
      // 如果下面展示不下去，就展示在上面
      if((heightAndTop-postion.bottom)<parseInt(height) ){
        this.el.nativeElement.style.top = postion.bottom - parseInt(height) +15 + 'px';
      }else {
        this.el.nativeElement.style.top = postion.bottom + 'px';
      }
    }
    
    //监听 myModalBody 盒子的滚动条事件
    this.myModalBodyScroll()  
    //监听 myWrapCont 盒子的滚动条事件
    this.myWrapContScroll()  
  }

  ngOnDestroy(): void {
    //移除 myModalBody 盒子的滚动条事件
    this.myModalBodyRmScroll()  
    //移除 myWrapCont 盒子的滚动条事件
    this.myWrapContRmScroll() 
  }

  /**
   * 失去焦点
   * @ignore
   */
  Blur() {
    setTimeout(() => {
      // 销毁组件
      this.closeSelect.emit(false)
    }, 200);
    event.stopImmediatePropagation();
  }

  /**
   * 监视全屏键盘事件
   * @ignore
   */
  @HostListener('document:mousewheel', ['$event']) onmousewheel(event) {
    //监视全屏键盘事件 如果是回车触发
    if(this.mouseo)
        this.closeSelect.emit(false)
  } 

  /**
   * 监视鼠标滚动事件
   * @ignore
   */
  @HostListener('document:scroll', ['$event'])
  windowScrolled($event) {
    this.closeSelect.emit(false)
  }
  //屏幕缩放时
  // @HostListener('window:resize', ['$event']) resize(event) {
  //   /* //屏幕缩放时,下拉框消失,否则下拉框
  //   this.closeSelect.emit(false) */
  //   //屏幕缩放时,重新设置下拉框的位置及宽度
  //   let postion = this.elem.nativeElement.getBoundingClientRect()
  //   this.el.nativeElement.style.top = postion.bottom + 'px';
  //   this.el.nativeElement.style.left = postion.left + 'px';
  //   this.el.nativeElement.style.width = postion.width + 'px';
  // }
  
  /**
   * 点击关闭
   * @ignore
   */
  close(e) {
    setTimeout(() => {
      // 销毁组件
      this.closeSelect.emit(false)
    }, 200);
  }

  /**
   * @ignore
   */
  mouseo:boolean = true;

  /**
   * @ignore
   */
  mouseoverEvent(){
    this.mouseo = false;
  }

  /**
   * @ignore
   */
  mouseoutEvent(){
    this.mouseo = true;
  }

  /**
   * @ignore
   * 监听 myWrapCont 盒子的滚动条事件,滚动就让日期控件消失
   */
  myWrapContScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  /**
   * @ignore
   * 页面销毁时,移除此事件
   */
  myWrapContRmScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myWrapContScroll)
    }
  }

  /**
   * @ignore
   * 监听 myModalBody 盒子的滚动条事件,滚动就让日期控件消失
   */
  myModalBodyScroll(){
    let scroll = $("#myModalBody")[0]
    if(scroll) {
      scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
      scroll.onscroll = ()=>{
        this.closeSelect.emit(false)
      }
    }
   
  }

  /**
   * @ignore
   * 页面销毁时,移除此事件
   */
  myModalBodyRmScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myModalBodyScroll)
    }
  }

  /**
   * 下拉框选中事件
   * @ignore
   */
  handleVotedClick(event) {
    let item = {
      'id': event.key,
      'text': event.title
    }
    this.dropdown = false;//关闭下拉框
    this.closeSelect.emit(item)
  }

  // 搜索框内容发生变化
  isHasRes(event){
    let keyword = $.trim(this.filter);
    if(!keyword){
      this.openLevel = 2;
      this.hasRes = true;
    }else{
      this.openLevel = 4;
      var newlist= this.data.filter(x=>x.text.indexOf(keyword)>=0);
      this.hasRes = newlist.length > 0;
    }
  }

  // 添加关系节点
  add(){
    // let relationName = $.trim(this.filter);
    // if(!relationName){
    //   this.box.danger('请输入关系名称!');
    //   return;
    // }
    // if(this.conceptGroup.sourceConceptId && this.conceptGroup.targetConceptId){
    //   let text = this.conceptGroup.sourceConceptName + '-' + this.conceptGroup.targetConceptName;
    //   let arr = this.data.filter(item => item.text == text);
    //   if(arr.length > 0){
    //     this.conceptGroup.conceptRelationshipId = arr[0].id;
    //   }
    //   // 保存关系信息
    //   let params = {
    //     "conceptRelationshipId": this.conceptGroup.conceptRelationshipId,
    //     "sourceConceptId": this.conceptGroup.sourceConceptId,
    //     "sourceConceptName": this.conceptGroup.sourceConceptName,
    //     "targetConceptId": this.conceptGroup.targetConceptId,
    //     "targetConceptName": this.conceptGroup.targetConceptName,
    //     "relationship": {
    //       "conceptRelationshipId": this.conceptGroup.conceptRelationshipId,
    //       "relationName": relationName,
    //       "relationLevel": 1,
    //       "parentId": this.conceptGroup.conceptRelationshipId
    //     }
    //   }
    //   this.kmsService.(params).subscribe(
    //       data => {
    //           if(data.code == '200'){
    //             this.box.success('添加成功!');
    //             let item = {
    //               'id': data.data.relationship.relationshipId,
    //               'text': data.data.relationship.relationName
    //             }
    //             this.dropdown = false;//关闭下拉框
    //             this.closeSelect.emit(item)
    //           }else{
    //             this.box.waring(data.msg);
    //           }
    //       }
    //   )
    // }else{
    //   this.box.danger('未指定起始子概念或指向子概念！');
    // }
  }
}
